<template>
  <div class="stat-card" :class="cardClass" :style="cardStyle">
    <div class="stat-bg"></div>
    <div v-if="icon" class="stat-icon" :class="iconClass"><i :class="icon"></i></div>
    <div class="stat-info">
      <div class="stat-number">{{ value }}</div>
      <div class="stat-label">{{ label }}</div>
      <div v-if="showPercent && percent !== null" class="stat-percent" :class="{ error: percentError }">{{ percent }}%</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    value: { type: [String, Number], default: '-' },
    label: { type: String, default: '' },
    icon: { type: String, default: '' },
    gradient: { type: String, default: 'var(--stat-gradient-1)' },
    active: { type: Boolean, default: false },
    inactive: { type: Boolean, default: false },
    percent: { type: [Number, String], default: null },
    showPercent: { type: Boolean, default: false }
  },
  computed: {
    cardStyle() { return { '--stat-gradient': this.gradient } },
    cardClass() { return { active: this.active, inactive: this.inactive } },
    iconClass() { return this.icon ? '' : 'no-icon' },
    percentError() { return this.inactive }
  }
}
</script>

<style lang="scss" scoped>
.stat-card {
  position: relative;
  padding: 12px 14px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
  overflow: hidden;

  .stat-bg { position: absolute; top: 0; right: 0; width: 80px; height: 80px; background: var(--stat-gradient); opacity: 0.1; border-radius: 0 10px 0 80px; transition: all .3s ease; }
  &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
  &:hover .stat-bg { opacity: 0.15; border-radius: 0 10px 0 60px; }

  .stat-icon { width: 36px; height: 36px; background: var(--stat-gradient); border-radius: 8px; display:flex; align-items:center; justify-content:center; flex-shrink:0; box-shadow:0 2px 8px rgba(0,0,0,0.12); color:#fff; i{font-size:16px} }

  .stat-info { flex:1; min-width:0 }
  .stat-number { font-size:22px; font-weight:600; color:#606266; line-height:1.2 }
  .stat-label { font-size:11px; color:#909399; margin-top:2px }
  .stat-percent { font-size:12px; color:#10b981; margin-top:6px }
  .stat-percent.error { color:#f56c6c }

  &.active .stat-number { color: #10b981 }
  &.inactive .stat-number { color: #f56c6c }
}
</style>
